export default __webpack_public_path__ + "lib/worker.min.6ae4421cc24575c3996815e8a7e47a34.js";